import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Location } from "@angular/common";


@Component({
    selector: 'app-billing-detail',
    templateUrl: './billing-detail.component.html'
})
export class BillingDetailComponent implements OnInit {
    orderType:any ='order';
    id:any;
    data:any ={};
    skLoading:boolean = false;
    savingFlag:boolean = false;
    userData:any;
    invoiceId:any
    
    invoice_detail:any={}
    lr_docs:any=[]
    material_docs:any=[]
    invoice_document:any=[]
    billing_list:any=[];
    dispatchItem:any =[];
    payment_list:any=[];
    dispatch_coupon:any=[];
    dispatch_detail:any ={};
    image_id: any;
    selectedFile: any = [];
    urls: any = [];
    image_url:any;
    loader:any;
    // expenseDetail:any={};
    
    
    constructor(public route:ActivatedRoute,public service:DatabaseService, public rout: Router,public location: Location,
        public dialog: MatDialog,public session:sessionStorage ,public dialogs:DialogComponent,public toast:ToastrManager,public alert:DialogComponent) { 
            
            this.userData = JSON.parse(localStorage.getItem('st_user'));
            this.data.created_by_id=this.userData['data']['id'];
            this.data.created_by_name=this.userData['data']['name'];
            
            this.route.params.subscribe( params => {
                console.log(params);
                this.invoiceId = params.id;
                console.log(this.invoiceId);
                
                // this.serve.currentUserID = params.id
                
            });
            
            console.log(this.invoiceId);
            
            
            this.route.params.subscribe( params => {
                this.id = params.id;
                this.service.currentUserID = params.id
                console.log(this.service.currentUserID);
            });
            
            console.log(this.service.currentUserID);
            this.image_url = service.uploadUrl + 'invoice/'
            console.log(this.image_url);
        }
        
        ngOnInit() {
            this.billDatadetail()
        }
        back(){
            this.location.back()
        }
        
        billDatadetail()
        {
            this.material_docs = [];
            this.lr_docs = [];
            this.skLoading = true;
            this.service.post_rqst({'bill_id': this.id},"Dispatch/tallyInvoiceCreditBillingDetail")
            .subscribe((result=>{
                if(result['statusCode']==200){
                    
                    this.invoice_detail=result['invoice_bill'];
                    console.log(this.invoice_detail);
                    
                    this.invoice_document = this.invoice_detail.images;
                    console.log(this.invoice_document);
                    
                    this.dispatch_detail=result['dispatch_data'];
                    this.billing_list=result['invoice_bill_item'];
                    for (let i = 0; i < this.billing_list.length; i++) {
                        this.dispatchItem.push({'item_code':this.billing_list[i]['item_code'], 'sale_qty':this.billing_list[i]['sale_qty'], 'item_name':this.billing_list[i]['item_name'], 'dispatch_qty':0, })
                    }
                    
                    console.log(this.invoice_document);
                    
                    for (let i = 0; i < this.invoice_document.length; i++) {
                        if (this.invoice_document[i].type == 'Material') {
                            this.material_docs.push({'image': this.invoice_document[i].image , 'type': this.invoice_document[i].type , 'id': this.invoice_document[i].id});
                            
                        }
                        else
                        {
                            this.lr_docs.push({'image': this.invoice_document[i].image , 'type': this.invoice_document[i].type , 'id': this.invoice_document[i].id});
                        }
                    }
                    
                    console.log(this.material_docs);
                    console.log(this.lr_docs);
                    
                    this.payment_list=result['payment_list'];
                    this.dispatch_coupon=result['all_dispatch'];
                    this.skLoading = false;
                    this.service.count_list();
                }else{
                    this.skLoading = false;
                    this.service.count_list();
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }
        
        saveinvoice_detailImage(image,upload_type){
            console.log(image , upload_type);
            this.savingFlag = true;
            
            this.service.post_rqst({'invoiceId':this.invoiceId,'invoiceImages': this.urls, 'upload_type': upload_type},"Account/invoiceImages").subscribe(result=>{
                if(result['statusCode']==200){
                    this.toast.successToastr('Image Save Successfully');
                    this.savingFlag = false;
                    this.urls = [];
                    this.material_docs = [];
                    this.lr_docs = [];
                    
                    this.billDatadetail();
                }else{
                    this.billDatadetail();
                    this.toast.errorToastr(result['statusMsg']);
                }
            }, err=>{
                this.billDatadetail();
                this.toast.errorToastr('Something went wrong');
                
            })
        }
        
        delete_img(index: any) {
            this.urls.splice(index, 1)
            this.selectedFile = [];
            
        }
        
        // https://devcrm.abacusdesk.com/millborndms/api/index.php/Account/deleteImages
        delete_Savedimg(id) {
            this.alert.confirm('Are you Sure you want to delete this image?').then((result) => {
                if (result) {
                    this.service.post_rqst({'invoiceId': this.invoiceId , 'invoiceImageId' :id, },"Account/deleteImages").subscribe(result=>{
                        if(result['statusCode']==200){
                            // this.expenseDetail = result['result'];
                            this.billDatadetail();
                        }else{
                            this.billDatadetail();
                            this.toast.errorToastr(result['statusMsg']);
                        }
                    }, err => {
                        this.loader = false;
                    })
                }
                else
                {
                    this.loader = false;
                    
                }
            })
            
        }
        
        insertImage(event) {
            let files = event.target.files;
            this.image_id = '';
            
            if (files) {
                for (let file of files) {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.urls.push(e.target.result);
                    }
                    reader.readAsDataURL(file);
                }
            }
            for (var i = 0; i < event.target.files.length; i++) {
                this.selectedFile.push(event.target.files[i]);
            }
        }
        
        
    }
    